
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[smartBanner]/[imagesFormat]/articles/[slug]",
      function () {
        return require("private-next-pages/[smartBanner]/[imagesFormat]/articles/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[smartBanner]/[imagesFormat]/articles/[slug]"])
      });
    }
  